export class PrecticeAnalyticsChartReqCommand {
  providerIds: string[];
  procedureCategoryIds: string[];
  procedureCodes: string[];
  locations: string[];
  period: string | null;
  frequency: string | null;
  name: string;
  carrierIds: string[];
  type: number;
  startDate: Date | string | null;
  endDate: Date | string | null;
  top: number;
  id: number;
  reportId: number;
  pushToDashboard: boolean;
  description: string | null;
  executivesummary: string | null;
  category: number | null;

  providers: GraphFilterModel[];
  categories: GraphFilterModel[];
  codes: GraphFilterModel[];
  carriers: GraphFilterModel[];
  practicies: GraphFilterModel[];
  graphImageUrl: string;
  chartData: ChartResp;
  fetchPreviousYear: boolean = false;
}

export class AssessmentReportModel {
  index: number;
  subIndex: number;
  filters: PrecticeAnalyticsChartReqCommand;
}

export class ReportSaveModel {
  id: number;
  graphImageUrl: string;
}

export class ChartSeries {
  key: string;
  value: number;
  value1: number;
  value2: number;
}

export class ChartResp {
  series: ChartSeries[];
  goal: number;
  xlabel: string;
  previousYearGoal: number;
  previousYearSeries: ChartSeries[];
  previousYearXlabel: string;
  ylabel: string;
  type: number;
  name: string;
  category: number;
  id: number;
  seriesLabel?: number;
  previousYearSeriesLabel?: number;
}

export class GraphModel {
  id: number;
  name: string;
  total: number;
  type: number;
  category: number;
}

export class AllChartResModel {
  graphs: GraphModel[];
}

export class AllChartsReqCommand {
  period: string;
  frequency: string | null;
  top: number;
  type: number;
  startDate: Date | string | null;
  endDate: Date | string | null;
  compare: boolean = false;
}
export class graphDomModel {
  id: number;
  showNoData: boolean = false;
  loader: boolean = true;
  chart: any = [];
  chartPreview: any = [];
  name: string = '';
  type: number = 0;
  compare: boolean = false;
}

export class ChartConfigModel {
  data: any;
  data1: any;
  data2: any;
  dataPrev: any;
  dataPrev1: any;
  dataPrev2: any;
  labels: any;
  goal: number;
  xLabel: string;
  yLabel: string;
}

export class GraphFilterModel {
  key: string;
  value: string;
}

export class GraphFilterDataModel {
  name: string;
  dataSource: GraphFilterModel[];
}

export class GraphFiltersResModel {
  filters: GraphFilterDataModel[];
}

export class GraphReqModel {
  providerIds?: [] = [];
  procedureCategoryIds?: string[] = [];
  procedureCodes?: string[] = [];
  locations?: string[] = [];
  period?: string;
  frequency?: string;
  carrierIds?: string[] = [];
  type?: string;
  startDate?: Date | string | null;
  endDate?: Date | string | null;
}

export class KPIDashboardTileReqModel {
  ids: number[];
  period?: string;
  startDate?: Date | string | null;
  endDate?: Date | string | null;
}

export class KPIDashboardTileModel {
  name: string;
  value: number | null;
  format: string;
  percentage: number | null;
   tileId: number;
}

export class KPIDashboardTileRepoModel {
  kpiDashboardTiles: KPIDashboardTileModel[];
}

export class GraphResModel {
  series: GraphFilterModel[];
  goal: number;
  duration: string;
}

export class GraphDetailModel {
  label: string[];
  data: number[];
}

export class ReportReqModel {
  id: number | 0;
  IsPublish: boolean | null = null;
}

export class MyReportRes {
  reports: myReportModel;
}
export class MyReportListRes {
  reports: myReportModel[];
}

export class myReportModel {
  id: number;
  graphId: number;
  title: string;
  description: string | null;
  executiveSummary: string | null;
  filters: string;
  isPublish: boolean;
  isActive: boolean;
  category: string;
  subCategory: string;
  graphImageUrl: string;
  graphImageByets: string | null;
  fetchPreviousYear: boolean;
}
export interface GetGraphReportDocumentRequest {
  graphIds: number[];
}

export class ReportDocumentModel {
  id: number;
  fileURL: string;
  title: string;
  status: string;
  createdOn: string;
  reportCatagery: string | null;
  reportType: string | null;
}

export class MasterReportRes {
  reports: MasterReportModel[];
  tiles : MasterTileList[];
}

export class MasterReportModel {
  id: number;
  name: string;
  category: string;
  subCategory: string;
  isActive: boolean;
  selected: boolean;
}
export class MasterTileList {
    id: number;
    name: string;
    selected: boolean;
}
export class AddUpdateMyReportReqModel {
  id: number | null;
  graphId: number;
  title: string;
  description: string | null;
  executiveSummary: string | null;
  filters: string | null;
  isPublish: boolean;
  graphImageByets?: string | null;
  fetchPreviousYear: boolean;
}

export class ReportPushToDashboardModel {
  ids: number[];
  tileIds: number[];
}

export class KPIDashboardTabModel {
  graphData: any[];
   tileIds: number[];
}
export class KPIDashboardTabRep {
  memberMasterGraph: KPIDashboardTabModel;
}

export class UpdateKPIDashboardTileConfigCommand {
  kpiDashboardTileIds: number[];
  practiceId: number;
}

export class RoleGraphConfigDto {
  practiceId: number;
  roleId: number;
  graphId: number;
}

export class RoleTileConfigDto {
  practiceId: number;
  roleId: number;
  tileId: number;
}

export class GraphConfigDto {
  graphId: number;
  name: string;
}

export class KPIDashboardTileConfigDto {
  tileId: number;
  name: string;
}

export class PracticeGraphsAndTilesListResponse {
  graphsList: GraphConfigDto[];
  tilesList: KPIDashboardTileConfigDto[];
}

